import { Terminal } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const TerminalIcon = createNavigationLucideIcon(Terminal);
